module.exports = __webpack_public_path__ + "img/sprite__panels.8484eb20.svg";